export enum PortTariffLineUnitTypes {
  FIXED = 'fixed',
  DAY = 'day',
  HOUR = 'hour',
  METER = 'meter',
  TON = 'ton',
  CARGO = 'cargo',
  CARGO_CBM = 'cargo_cbm',
  CARGO_MT = 'cargo_mt',
  CARGO_WM = 'cargo_wm',
  PCT = 'pct',
}

// Every "per cargo unit" family: they all price against a cargo measure (unit count,
// CBM, MT, or W/M) instead of a vessel property, so they share the same UI/validation
// rules (no vessel property, optional cargo-type filter).
export const CARGO_UNIT_TYPES: PortTariffLineUnitTypes[] = [
  PortTariffLineUnitTypes.CARGO,
  PortTariffLineUnitTypes.CARGO_CBM,
  PortTariffLineUnitTypes.CARGO_MT,
  PortTariffLineUnitTypes.CARGO_WM,
];

export function isCargoUnitType(unitType: unknown): boolean {
  return CARGO_UNIT_TYPES.includes(unitType as PortTariffLineUnitTypes);
}
